import { render, staticRenderFns } from "./product-groups-v2.modal.vue?vue&type=template&id=1b9c70d8&scoped=true"
import script from "./product-groups-v2.modal.vue?vue&type=script&lang=js"
export * from "./product-groups-v2.modal.vue?vue&type=script&lang=js"
import style0 from "./product-groups-v2.modal.vue?vue&type=style&index=0&id=1b9c70d8&prod&lang=scss&scoped=true"
import style1 from "./product-groups-v2.modal.vue?vue&type=style&index=1&id=1b9c70d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9c70d8",
  null
  
)

export default component.exports